import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomInput, CustomInputProps } from '../../../custom_shared/components';
import { WithInput } from '../../types';
import { useInputHighlighting, useGlobalInputState } from '../../hooks';

export type CustomInputWrapperProps = WithInput<CustomInputProps>;

const CustomInputWrapper: React.FC<CustomInputWrapperProps> = (props: CustomInputWrapperProps) => {
    const { input, ...rest } = props;

    const [containerRef, setContainerRef] = React.useState<React.RefObject<HTMLDivElement> | null>(null);

    const { containerStyle } = useInputHighlighting(input, containerRef);

    const globalInputState = useGlobalInputState(input, props);

    return (
        <CustomInput
            containerStyle={containerStyle}
            getContainerRef={setContainerRef}
            {...rest}
            {...globalInputState}
        />
    );
};

export default observer(CustomInputWrapper);
